export default "__VITE_ASSET__03bc2a39__"